import diagramHywind from "../diagram-hywind.json";

export type SingleLineConfig = typeof diagramHywind;

export const TurbineOptions = {
  turbineStatus: "turbineStatus",
  personnelStatus: "personnelStatus",
  interlockStatus: "interlockStatus",
} as const;

export type TurbineOptions =
  (typeof TurbineOptions)[keyof typeof TurbineOptions];
